import {
  COMMISSION_HOLD_DAYS,
} from './types';

export function calculateCommission(amountPaidCents: number, rate: number): number {
  if (amountPaidCents <= 0 || rate <= 0) return 0;
  return Math.floor(amountPaidCents * rate);
}

export function commissionAvailableAt(paidAt: Date, holdDays = COMMISSION_HOLD_DAYS): Date {
  const result = new Date(paidAt);
  result.setUTCDate(result.getUTCDate() + holdDays);
  return result;
}

export function isWithinCommissionWindow(commissionEndsAt: Date, paidAt: Date): boolean {
  return paidAt.getTime() <= commissionEndsAt.getTime();
}

/** Mirrors handle_new_user: partner owner cannot refer their own new signup. */
export function shouldAttributePartnerReferral(
  partnerUserId: string,
  signupUserId: string,
): boolean {
  return partnerUserId !== signupUserId;
}

export function shouldAccrueCommission(params: {
  amountPaid: number;
  billingReason: string | null;
  commissionEndsAt: Date;
  paidAt: Date;
}): boolean {
  const { amountPaid, commissionEndsAt, paidAt } = params;
  if (amountPaid <= 0) return false;
  if (!isWithinCommissionWindow(commissionEndsAt, paidAt)) return false;
  return true;
}

export function normalizePartnerCode(code: string | null | undefined): string | null {
  if (!code) return null;
  const normalized = code.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
  return normalized.length >= 3 ? normalized : null;
}

export function generatePartnerCodeFromCompany(companyName: string): string {
  const base = companyName
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 24);
  const suffix = Math.random().toString(36).slice(2, 6);
  return `${base || 'agencia'}-${suffix}`;
}
